<button
  id="video-guide-btn"
  class="video-guide"
  [hidden]="watchVideoConfig.isIconHide"
  (click)="IsvideoActive(true);">
  <img [src]="icons.PLAY_FILLED" alt="Video" />
  {{ 'Video Guide' | translate }}
</button>
<ds-modal [modalInput]="modalConfig" (visibleChange)="onModalVisibleChange($event)">
  <div modal-body>
    @if(modalConfig.visible) {
      @if(showLoading){<div class="show-iframe-loader">
        <img src="../../assets/images/solo_loader.gif" alt="">
      </div>}
      <div [class.d-none]="showLoading" class="video-frame-wrapper">
        <iframe [src]='watchVideoConfig.videoUrl | safeUrl'
        referrerpolicy="strict-origin-when-cross-origin"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        (load)="onLoad($event)"
        width="100%"
        height="450px"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen>
        </iframe>
      </div>
     
      @if(watchVideoConfig.showBenefits && watchVideoConfig.benefitsList?.length)
      {
        <div class="primary-info-container mt-3">
          <h6 class="title-14">{{ watchVideoConfig.benefitsHeading | translate }}</h6>
          <ul class="ds-info-text --icon-bullet --primary">
            @for (benefit of watchVideoConfig.benefitsList; track benefit) 
            {
              <li>{{ benefit | translate }}</li>
            }
          </ul>
        </div>
      }
    }
  </div>
</ds-modal>
